import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const datePeriodDictionary = createSimpleDictionary([
    { id: 'today', name: 'bookBalance.datePeriod.today' },
    { id: 'yesterday', name: 'bookBalance.datePeriod.yesterday' },
    { id: 'currentWeek', name: 'bookBalance.datePeriod.currentWeek' },
    { id: 'lastWeek', name: 'bookBalance.datePeriod.lastWeek' },
    { id: 'currentMonth', name: 'bookBalance.datePeriod.currentMonth' },
    { id: 'lastMonth', name: 'bookBalance.datePeriod.lastMonth' },
    { id: 'currentYear', name: 'bookBalance.datePeriod.currentYear' },
    { id: 'range', name: 'bookBalance.datePeriod.range' },
]);
